// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"480":"39de9a30","503":"4fd2e816","777":"8b9f1201"}[chunkId] + ".js";
};